import React, { useState } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Sun02FreeIcons, Moon02FreeIcons } from '@hugeicons/core-free-icons';
import { Search01Icon, Location01Icon, MapsIcon, Megaphone02Icon, FavouriteIcon, BalanceScaleIcon, User02Icon, Building01Icon, CustomerSupportIcon } from 'hugeicons-react';
import { CATS, TC } from '../data/constants';
import { TURKEY_CITIES } from '../lib/turkey';

const makeC = (theme) => (k) => {
  const d = theme === 'dark';
  const m = {
    bg:d?'#0d1117':'#FFF8F0',
    surf:d?'#141924':'#FFFAF5',
    surf2:d?'rgba(255,255,255,0.03)':'rgba(139,92,246,0.04)',
    card:d?'#141924':'#FFF3E6',
    bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',
    bord2:d?'rgba(255,255,255,0.12)':'rgba(139,92,246,0.14)',
    txt:d?'#ffffff':'#1E1048',
    txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',
    txt3:d?'rgba(255,255,255,0.25)':'#9B8FBD',
    inp:d?'rgba(255,255,255,0.05)':'rgba(139,92,246,0.06)',
    nav:d?'rgba(13,17,23,0.96)':'rgba(255,248,240,0.97)',
  };
  return m[k]||'';
};

export function MobileTopBar({
  theme, MAPBOX_TOKEN,
  mode, setMode, showEvents, setShowEvents, setTheme,
  user, setShowAuth, setMobileTab,
  search, setSearch, places, mapRef, setDetailId,
  openLocationModal,
  selectedIl, setSelectedIl, selectedIlce, setSelectedIlce,
  selectedMahalleler, setSelectedMahalleler, mahalleResults,
  onAddSchool, onSupport,
}) {
  const C = makeC(theme);
  const isDark = theme === 'dark';
  const [moreOpen, setMoreOpen] = useState(false);
  const activeMod = mode==='heat' || mode==='zone' || mode==='cluster' || showEvents;
  return (
    <div style={{
      position:'sticky',top:0,
      padding:'12px 16px 0',
      paddingTop:'calc(12px + env(safe-area-inset-top, 0px))',
      background:C('nav'),
      backdropFilter:'blur(16px)',
      WebkitBackdropFilter:'blur(16px)',
      borderBottom:'1px solid '+C('bord'),
      paddingBottom:10,
      flexShrink:0,
      zIndex:100,
    }}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12,position:'relative'}}>
        {/* Logo + yazı */}
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <img src="/logo.png?v=3" alt="OkulMap" style={{height:40,objectFit:'contain'}} />
          <span style={{fontFamily:'Syne,sans-serif',fontWeight:800,fontSize:17,letterSpacing:'-0.3px',color:C('txt')}}>
            <span style={{color:'#A8DAFF'}}>Okul</span>Map
          </span>
        </div>
        <div style={{display:'flex',gap:6,alignItems:'center'}}>
          {onAddSchool && (
            <button onClick={onAddSchool} aria-label="Okul/Kurum Ekle" title="Okul/Kurum Ekle"
              style={{width:32,height:32,borderRadius:8,background:'rgba(168,218,255,0.14)',border:'1px solid rgba(168,218,255,0.4)',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',flexShrink:0}}>
              <Building01Icon size={16} color="#A8DAFF" />
            </button>
          )}
          {onSupport && (
            <button onClick={onSupport} aria-label="Bize Ulaşın" title="Bize Ulaşın"
              style={{width:32,height:32,borderRadius:8,background:'rgba(78,205,196,0.14)',border:'1px solid rgba(78,205,196,0.4)',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',flexShrink:0}}>
              <CustomerSupportIcon size={16} color="#4ECDC4" />
            </button>
          )}
          <button onClick={()=>setTheme(t=>t==='dark'?'light':'dark')}
            style={{width:32,height:32,borderRadius:8,background:C('inp'),border:'1px solid '+C('bord'),display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',flexShrink:0}}>
            <HugeiconsIcon icon={isDark?Sun02FreeIcons:Moon02FreeIcons} size={15} color={isDark?'#FFE66D':'#6366f1'} />
          </button>
          <button onClick={()=>setMoreOpen(v=>!v)} aria-label="Daha fazla"
            style={{width:32,height:32,borderRadius:8,background:activeMod?'rgba(168,218,255,0.18)':C('inp'),border:'1px solid '+(activeMod?'rgba(168,218,255,0.5)':C('bord')),color:activeMod?'#A8DAFF':C('txt2'),display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',flexShrink:0,fontSize:18,fontWeight:700,lineHeight:1,paddingBottom:6}}>
            ⋯
          </button>
          {user ? (
            <div style={{width:32,height:32,borderRadius:'50%',background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'#000',cursor:'pointer',flexShrink:0}}
              onClick={()=>setMobileTab('profile')}>
              {(user.name||user.email||'?')[0].toUpperCase()}
            </div>
          ) : (
            <button onClick={()=>setShowAuth(true)} style={{padding:'7px 12px',borderRadius:8,background:'rgba(168,218,255,0.15)',border:'1px solid rgba(168,218,255,0.35)',color:'#A8DAFF',fontSize:11,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',whiteSpace:'nowrap'}}>
              Giriş
            </button>
          )}
        </div>
        {moreOpen && (
          <>
            <div onClick={()=>setMoreOpen(false)} style={{position:'fixed',inset:0,zIndex:998}}/>
            <div style={{position:'absolute',top:'100%',right:0,marginTop:6,minWidth:180,background:C('surf'),border:'1px solid '+C('bord2'),borderRadius:12,boxShadow:'0 12px 32px rgba(0,0,0,0.4)',overflow:'hidden',zIndex:999}}>
              <button onClick={()=>{ setMode(mode==='heat'?'normal':'heat'); setMoreOpen(false); }}
                style={{width:'100%',padding:'12px 14px',background:'none',border:'none',borderBottom:'1px solid '+C('bord'),color:mode==='heat'?'#A8DAFF':C('txt'),fontSize:13,textAlign:'left',cursor:'pointer',fontFamily:'DM Sans,sans-serif',fontWeight:mode==='heat'?700:400,display:'flex',alignItems:'center',gap:10}}>
                <span style={{fontSize:16}}>🔥</span> Isı haritası {mode==='heat'&&<span style={{marginLeft:'auto',fontSize:11,color:'#A8DAFF'}}>✓</span>}
              </button>
              <button onClick={()=>{ setMode(mode==='cluster'?'normal':'cluster'); setMoreOpen(false); }}
                style={{width:'100%',padding:'12px 14px',background:'none',border:'none',borderBottom:'1px solid '+C('bord'),color:mode==='cluster'?'#FF6B6B':C('txt'),fontSize:13,textAlign:'left',cursor:'pointer',fontFamily:'DM Sans,sans-serif',fontWeight:mode==='cluster'?700:400,display:'flex',alignItems:'center',gap:10}}>
                <span style={{fontSize:16}}>📍</span> Yoğunluk (cluster) {mode==='cluster'&&<span style={{marginLeft:'auto',fontSize:11,color:'#FF6B6B'}}>✓</span>}
              </button>
              <button onClick={()=>{ setMode(mode==='zone'?'normal':'zone'); setMoreOpen(false); }}
                style={{width:'100%',padding:'12px 14px',background:'none',border:'none',borderBottom:'1px solid '+C('bord'),color:mode==='zone'?'#4ECDC4':C('txt'),fontSize:13,textAlign:'left',cursor:'pointer',fontFamily:'DM Sans,sans-serif',fontWeight:mode==='zone'?700:400,display:'flex',alignItems:'center',gap:10}}>
                <span style={{fontSize:16}}>🗺</span> Yaş bölgesi {mode==='zone'&&<span style={{marginLeft:'auto',fontSize:11,color:'#4ECDC4'}}>✓</span>}
              </button>
              <button onClick={()=>{ setShowEvents(v=>!v); setMoreOpen(false); }}
                style={{width:'100%',padding:'12px 14px',background:'none',border:'none',color:showEvents?'#FF8C42':C('txt'),fontSize:13,textAlign:'left',cursor:'pointer',fontFamily:'DM Sans,sans-serif',fontWeight:showEvents?700:400,display:'flex',alignItems:'center',gap:10}}>
                <span style={{fontSize:16}}>📅</span> Etkinlikler {showEvents&&<span style={{marginLeft:'auto',fontSize:11,color:'#FF8C42'}}>✓</span>}
              </button>
            </div>
          </>
        )}
      </div>
      <div style={{display:'flex',gap:8,marginBottom:10,position:'relative'}}>
        <div style={{flex:1,display:'flex',alignItems:'center',background:C('inp'),border:'1px solid '+(search?'rgba(168,218,255,0.4)':C('bord2')),borderRadius:12,padding:'0 12px',gap:8}}>
          <Search01Icon size={16} color={C('txt3')} />
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Kurum adı veya özellik ara..."
            style={{flex:1,background:'none',border:'none',outline:'none',color:C('txt'),fontSize:16,padding:'10px 0',fontFamily:'DM Sans,sans-serif',touchAction:'manipulation'}}/>
          {search&&<button onClick={()=>setSearch('')} style={{background:'none',border:'none',color:C('txt3'),cursor:'pointer',fontSize:14,touchAction:'manipulation'}}>✕</button>}
        </div>
        <button onClick={openLocationModal}
          style={{width:42,height:42,borderRadius:12,flexShrink:0,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 4px 15px rgba(168,218,255,0.25)'}}>
          <Location01Icon size={18} color="#000" />
        </button>
        {/* Arama önerileri dropdown */}
        {search.trim().length > 0 && (()=>{
          const trNorm = s => (s||'').toLowerCase().replace(/ı/g,'i').replace(/ş/g,'s').replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ö/g,'o').replace(/ç/g,'c');
          const q = trNorm(search);
          const suggestions = places.filter(p => {
            if (!q || q.length < 1) return false;
            const name     = trNorm(p.name     || '');
            const city     = trNorm(p.city     || '');
            const district = trNorm(p.district || '');
            const neighborhood = trNorm(p.neighborhood || '');
            return name.includes(q) || city.includes(q) || district.includes(q) || neighborhood.includes(q);
          }).slice(0, 20);
          if (!suggestions.length) return null;
          return (
            <div style={{position:'absolute',top:'100%',left:0,right:50,zIndex:99999,background:C('surf'),border:'1px solid '+C('bord2'),borderRadius:12,marginTop:4,overflow:'hidden',boxShadow:'0 8px 24px rgba(0,0,0,0.3)'}}>
              {suggestions.map(p => {
                const color = TC[p.type] || '#A8DAFF';
                const cat = CATS.find(c=>c.id===p.type)||{};
                return (
                  <div key={p.id} onTouchEnd={()=>{ setSearch(''); setDetailId(p.id); if(mapRef.current) mapRef.current.flyTo({center:[p.lng,p.lat],zoom:16,duration:700}); setMobileTab('map'); }} onClick={()=>{ setSearch(''); setDetailId(p.id); if(mapRef.current) mapRef.current.flyTo({center:[p.lng,p.lat],zoom:16,duration:700}); setMobileTab('map'); }}
                    style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',borderBottom:'1px solid '+C('bord'),cursor:'pointer'}}>
                    <div style={{width:32,height:32,borderRadius:9,background:color+'18',border:'1px solid '+color+'30',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,flexShrink:0}}>{cat.icon||'🏫'}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{color:C('txt'),fontSize:13,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{p.name}</div>
                      <div style={{color:C('txt3'),fontSize:11,marginTop:1}}>★ {p.rating} · {p.age}</div>
                    </div>
                    <div style={{color:color,fontSize:11,fontWeight:700,flexShrink:0}}>{p.price}</div>
                  </div>
                );
              })}
            </div>
          );
        })()}
      </div>
      {/* İl / İlçe / Mahalle — native select (iOS picker wheel) */}
      {(()=>{
        const chevronSvg = (
          <svg width="9" height="5" viewBox="0 0 9 5" fill="none" style={{position:'absolute',right:9,top:'50%',transform:'translateY(-50%)',pointerEvents:'none',flexShrink:0}}>
            <path d="M1 1L4.5 4.5L8 1" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
        return (
          <div style={{paddingBottom:6}}>
            <div style={{display:'flex',gap:6}}>
              {/* İl */}
              <div style={{flex:1,position:'relative',zIndex:9999,pointerEvents:'auto'}}>
                <select
                  value={selectedIl}
                  onChange={e=>{ setSelectedIl(e.target.value); setSelectedIlce(''); setSelectedMahalleler([]); }}
                  onTouchEnd={e=>e.currentTarget.focus()}
                  className={'mob-select'+(selectedIl?' has-value':'')}
                  style={{pointerEvents:'auto',background:selectedIl?C('card'):C('surf'),border:'1px solid '+C('bord2'),color:selectedIl?C('txt'):C('txt3'),colorScheme:isDark?'dark':'light'}}
                >
                  <option value="">İl</option>
                  {TURKEY_CITIES.map(c=><option key={c.il} value={c.il}>{c.il}</option>)}
                </select>
                {chevronSvg}
              </div>
              {/* İlçe */}
              <div style={{flex:1,position:'relative',zIndex:9999,pointerEvents:'auto'}}>
                <select
                  value={selectedIlce}
                  onChange={e=>{ setSelectedIlce(e.target.value); setSelectedMahalleler([]); }}
                  onTouchEnd={e=>{ if(selectedIl) e.currentTarget.focus(); }}
                  disabled={!selectedIl}
                  className={'mob-select'+(selectedIlce?' has-value':'')}
                  style={{pointerEvents:'auto',background:selectedIlce?C('card'):C('surf'),border:'1px solid '+C('bord2'),color:selectedIlce?C('txt'):C('txt3'),colorScheme:isDark?'dark':'light'}}
                >
                  <option value="">İlçe</option>
                  {(TURKEY_CITIES.find(c=>c.il===selectedIl)?.ilceler||[]).map(d=><option key={d} value={d}>{d}</option>)}
                </select>
                {chevronSvg}
              </div>
              {/* Mahalle */}
              {selectedIlce && mahalleResults.length>0 && (
                <div style={{flex:1,position:'relative',zIndex:9999,pointerEvents:'auto'}}>
                  <select
                    value=""
                    onChange={e=>{
                      const name = e.target.value;
                      if (!name) return;
                      e.target.value = '';
                      const r = mahalleResults.find(x=>x.name===name);
                      if (!r) return;
                      if (selectedMahalleler.find(m=>m.name===name)) return;
                      const geoKey = 'okulmap_geo_'+name+','+selectedIlce;
                      const cached = (() => { try { const v=localStorage.getItem(geoKey); return v?JSON.parse(v):null; } catch(e){ return null; } })();
                      const addZoom = (center) => {
                        setSelectedMahalleler(prev=>[...prev,{name,center}]);
                        if (center && mapRef.current) mapRef.current.flyTo({center,zoom:14,duration:700});
                      };
                      if (cached) { addZoom(cached); } else {
                        fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+encodeURIComponent(name+', '+selectedIlce+', '+selectedIl)+'.json?country=TR&language=tr&limit=1&access_token='+MAPBOX_TOKEN)
                          .then(res=>res.json())
                          .then(d=>{ const c=d.features?.[0]?.center||null; if(c) try{localStorage.setItem(geoKey,JSON.stringify(c));}catch(e){} addZoom(c); })
                          .catch(()=>addZoom(null));
                      }
                    }}
                    className={'mob-select'+(selectedMahalleler.length>0?' has-value':'')}
                    style={{pointerEvents:'auto'}}
                  >
                    <option value="">{selectedMahalleler.length>0?selectedMahalleler.length+' mah.':'Mahalle'}</option>
                    {mahalleResults.map(r=><option key={r.name} value={r.name}>{r.name}</option>)}
                  </select>
                  {chevronSvg}
                </div>
              )}
              {(selectedIl||selectedIlce) && (
                <button onClick={()=>{ setSelectedIl(''); setSelectedIlce(''); setSelectedMahalleler([]); }}
                  style={{padding:'9px 10px',borderRadius:9,border:'1px solid rgba(255,80,80,0.25)',background:'rgba(255,80,80,0.08)',color:'rgba(255,130,130,0.8)',fontSize:13,cursor:'pointer',flexShrink:0,touchAction:'manipulation',fontFamily:'DM Sans,sans-serif',lineHeight:1}}>
                  ✕
                </button>
              )}
            </div>
            {selectedMahalleler.length>0 && (
              <div style={{display:'flex',flexWrap:'wrap',gap:4,marginTop:6}}>
                {selectedMahalleler.map(m=>(
                  <span key={m.name} style={{display:'inline-flex',alignItems:'center',gap:3,background:'rgba(168,218,255,0.12)',border:'1px solid rgba(168,218,255,0.28)',borderRadius:20,padding:'4px 8px 4px 10px',fontSize:12,color:'#A8DAFF',fontFamily:'DM Sans,sans-serif'}}>
                    {m.name}<span onClick={()=>setSelectedMahalleler(prev=>prev.filter(x=>x.name!==m.name))} style={{cursor:'pointer',opacity:0.6,fontSize:14,lineHeight:1,marginLeft:2,touchAction:'manipulation'}}>×</span>
                  </span>
                ))}
              </div>
            )}
          </div>
        );
      })()}
    </div>
  );
}

export function MobileCategoryBar({ theme, activeCategory, setActiveCategory, showAllCats, setShowAllCats, catBarRef }) {
  const C = makeC(theme);
  const arrowBtn = (label, onClick) => (
    <button onClick={onClick} style={{flexShrink:0,width:32,height:36,display:'flex',alignItems:'center',justifyContent:'center',background:C('nav'),border:'none',borderRight: label==='‹' ? '1px solid '+C('bord') : 'none',borderLeft: label==='›' ? '1px solid '+C('bord') : 'none',color:C('txt2'),fontSize:18,cursor:'pointer',touchAction:'manipulation',fontFamily:'DM Sans,sans-serif',lineHeight:1}}>
      {label}
    </button>
  );
  return (
    <div style={{display:'flex',alignItems:'center',background:C('nav'),borderBottom:'1px solid '+C('bord')}}>
      {showAllCats && arrowBtn('‹', () => {
        setShowAllCats(false);
        if (catBarRef.current) catBarRef.current.scrollTo({left:0, behavior:'smooth'});
      })}
      <div ref={catBarRef} style={{display:'flex',gap:5,padding:'6px 10px',overflowX:'auto',flex:1,WebkitOverflowScrolling:'touch',scrollbarWidth:'none'}}>
        {CATS.map(c => {
          const isAct = activeCategory === c.id;
          return (
            <button key={c.id} onClick={()=>setActiveCategory(c.id)}
              style={{display:'flex',alignItems:'center',gap:4,padding:'4px 9px',borderRadius:20,background:isAct?c.color+'22':'transparent',border:'1px solid '+(isAct?c.color+'60':C('bord')),color:isAct?c.color:C('txt2'),fontSize:10,fontWeight:isAct?700:400,cursor:'pointer',whiteSpace:'nowrap',flexShrink:0,fontFamily:'DM Sans,sans-serif',touchAction:'manipulation'}}>
              {c.icon} {c.label}
            </button>
          );
        })}
      </div>
      {!showAllCats && arrowBtn('›', () => {
        setShowAllCats(true);
        if (catBarRef.current) catBarRef.current.scrollTo({left: catBarRef.current.scrollWidth, behavior:'smooth'});
      })}
    </div>
  );
}

export function MobileFilterSheet({ theme, showMobileFilter, setShowMobileFilter, userPos, sortBy, setSortBy, selectedAgeGroup, setSelectedAgeGroup, priceRange, setPriceRange, displayFiltered }) {
  const C = makeC(theme);
  if (!showMobileFilter) return null;
  return (
    <div style={{position:'fixed',inset:0,zIndex:500,display:'flex',flexDirection:'column',justifyContent:'flex-end',background:'rgba(0,0,0,0.5)',backdropFilter:'blur(4px)'}} onClick={()=>setShowMobileFilter(false)}>
      <div style={{background:C('bg'),borderRadius:'20px 20px 0 0',borderTop:'1px solid '+C('bord'),padding:'20px 20px calc(20px + env(safe-area-inset-bottom,0px))',maxHeight:'75vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
        {/* Handle */}
        <div style={{width:40,height:4,borderRadius:2,background:C('bord2'),margin:'0 auto 20px'}}/>
        <div style={{fontSize:14,fontWeight:700,color:C('txt'),marginBottom:16}}>Filtrele</div>

        {/* Sıralama */}
        <div style={{marginBottom:18}}>
          <div style={{fontSize:11,color:C('txt3'),fontWeight:600,marginBottom:8,letterSpacing:'0.06em'}}>SIRALAMA</div>
          <div style={{display:'flex',gap:6}}>
            {[{id:'distance',label:'Yakın'},{id:'rating',label:'Puan'},{id:'price',label:'Fiyat'},{id:'name',label:'İsim'}].filter(s=>s.id!=='distance'||userPos).map(s=>{
              const isAct = sortBy===s.id;
              return <button key={s.id} onClick={()=>setSortBy(s.id)} style={{flex:1,padding:'8px 4px',borderRadius:8,fontSize:11,background:isAct?'rgba(168,218,255,0.14)':'rgba(255,255,255,0.04)',border:'1px solid '+(isAct?'rgba(168,218,255,0.5)':C('bord')),color:isAct?'#A8DAFF':C('txt2'),cursor:'pointer',fontWeight:isAct?700:400,fontFamily:'DM Sans,sans-serif'}}>{s.label}</button>;
            })}
          </div>
        </div>

        {/* Yaş Grubu */}
        <div style={{marginBottom:18}}>
          <div style={{fontSize:11,color:C('txt3'),fontWeight:600,marginBottom:8,letterSpacing:'0.06em'}}>YAŞ GRUBU</div>
          <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
            {[null,'0-2','2-4','4-6','6-9','9-12','12+'].map(a=>{
              const isAct = selectedAgeGroup===a;
              return <button key={String(a)} onClick={()=>setSelectedAgeGroup(a)} style={{padding:'7px 12px',borderRadius:8,fontSize:11,background:isAct?'rgba(168,218,255,0.14)':'rgba(255,255,255,0.04)',border:'1px solid '+(isAct?'rgba(168,218,255,0.5)':C('bord')),color:isAct?'#A8DAFF':C('txt2'),cursor:'pointer',fontWeight:isAct?700:400,fontFamily:'DM Sans,sans-serif'}}>{a===null?'Tümü':a+' yaş'}</button>;
            })}
          </div>
        </div>

        {/* Fiyat Aralığı */}
        <div style={{marginBottom:20}}>
          <div style={{fontSize:11,color:C('txt3'),fontWeight:600,marginBottom:8,letterSpacing:'0.06em'}}>MAX AYLIK BÜTÇE</div>
          <div style={{position:'relative',marginBottom:10}}>
            <span style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:C('txt2'),fontSize:14,fontWeight:600,pointerEvents:'none'}}>₺</span>
            <input type="number" min="0" step="500" value={priceRange[1]<50000?priceRange[1]:''} placeholder="örn. 4.000"
              onChange={e=>{ const v=Number(e.target.value); setPriceRange([priceRange[0], v>0?v:50000]); }}
              style={{width:'100%',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:10,padding:'11px 14px 11px 30px',color:C('txt'),fontSize:14,outline:'none',fontFamily:'DM Sans,sans-serif',boxSizing:'border-box'}}/>
          </div>
          <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
            {[[0,50000],[0,2000],[0,4000],[0,6000],[0,10000],[0,20000]].map(([lo,hi])=>{
              const isAct = priceRange[0]===lo&&priceRange[1]===hi;
              const label = hi===50000?'Tümü':'≤ ₺'+(hi>=1000?hi/1000+'k':hi);
              return <button key={lo+'-'+hi} onClick={()=>setPriceRange([lo,hi])} style={{padding:'7px 12px',borderRadius:8,fontSize:11,background:isAct?'rgba(168,218,255,0.14)':'rgba(255,255,255,0.04)',border:'1px solid '+(isAct?'rgba(168,218,255,0.5)':C('bord')),color:isAct?'#A8DAFF':C('txt2'),cursor:'pointer',fontWeight:isAct?700:400,fontFamily:'DM Sans,sans-serif'}}>{label}</button>;
            })}
          </div>
        </div>

        <button onClick={()=>setShowMobileFilter(false)} style={{width:'100%',padding:'12px',borderRadius:12,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
          {displayFiltered.length} Kurumu Gör
        </button>
      </div>
    </div>
  );
}

export function LocationPermissionModal({ showLocPermModal, setShowLocPermModal, openLocationModal, setLocModalStep }) {
  if (!showLocPermModal) return null;
  const step = (text) => (
    <span style={{color:'rgba(255,255,255,0.55)',fontSize:12,lineHeight:1.7}}>{text}</span>
  );
  return (
    <div style={{position:'fixed',inset:0,zIndex:2100,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.85)',backdropFilter:'blur(10px)',padding:'20px'}}
      onClick={()=>setShowLocPermModal(false)}>
      <div style={{background:'#141920',border:'1px solid rgba(255,255,255,0.08)',borderRadius:20,padding:'28px 24px',maxWidth:380,width:'100%',boxShadow:'0 24px 64px rgba(0,0,0,0.6)'}}
        onClick={e=>e.stopPropagation()}>

        {/* Başlık */}
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{fontSize:44,lineHeight:1,marginBottom:12}}>📍</div>
          <div style={{fontSize:17,fontWeight:700,color:'#fff',marginBottom:8}}>Konum İzni Kapalı</div>
          <div style={{fontSize:13,color:'rgba(255,255,255,0.45)',lineHeight:1.6}}>
            Konumunuzu bulmak için tarayıcı<br/>konum iznini açmanız gerekiyor.
          </div>
        </div>

        {/* iPhone */}
        <div style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.07)',borderRadius:14,padding:'14px 16px',marginBottom:10}}>
          <div style={{fontSize:12,fontWeight:700,color:'rgba(255,255,255,0.8)',marginBottom:10}}>📱 iPhone için</div>
          <div style={{display:'flex',flexDirection:'column',gap:4}}>
            {step('Ayarlar → Gizlilik ve Güvenlik')}
            {step('→ Konum Servisleri')}
            {step('→ Safari veya Chrome')}
            {step('→ "Uygulamayı Kullanırken" seç')}
          </div>
        </div>

        {/* Android */}
        <div style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.07)',borderRadius:14,padding:'14px 16px',marginBottom:20}}>
          <div style={{fontSize:12,fontWeight:700,color:'rgba(255,255,255,0.8)',marginBottom:10}}>🤖 Android için</div>
          <div style={{display:'flex',flexDirection:'column',gap:4}}>
            {step('Ayarlar → Uygulamalar → Chrome')}
            {step('→ İzinler → Konum')}
            {step('→ İzin Ver')}
          </div>
        </div>

        {/* Butonlar */}
        <button onClick={()=>{ setShowLocPermModal(false); openLocationModal(); setLocModalStep('manual'); }}
          style={{width:'100%',padding:'13px',borderRadius:12,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#0a1520',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',marginBottom:8}}>
          🏙️ İl/İlçe Seçerek Devam Et
        </button>
        <button onClick={()=>setShowLocPermModal(false)}
          style={{width:'100%',padding:'11px',borderRadius:12,background:'transparent',border:'1px solid rgba(255,255,255,0.08)',color:'rgba(255,255,255,0.35)',fontSize:13,fontWeight:500,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
          Daha Sonra
        </button>
      </div>
    </div>
  );
}

export function LocationOnboardingModal({
  theme, isMobile, MAPBOX_TOKEN,
  showLocationModal, setShowLocationModal,
  locModalStep, setLocModalStep,
  locModalGpsError, setLocModalGpsError,
  setUserPos, setSortBy, setLocLabel, setMobileTab,
  mapRef, showToast, setShowLocPermModal,
  locModalIl, locModalIlce,
  setSelectedIl, setSelectedIlce, ilceCenterRef,
}) {
  const C = makeC(theme);
  if (!showLocationModal) return null;

  const handleGPSInModal = () => {
    setLocModalStep('gps_loading');
    if (!navigator.geolocation) {
      setLocModalGpsError('Tarayıcınız konum desteklemiyor.');
      setLocModalStep('gps_error');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { longitude, latitude } = pos.coords;
        setUserPos({ lng: longitude, lat: latitude });
        setSortBy('distance');
        setLocLabel('Konumunuz');
        localStorage.setItem('okulmap_location_type', 'gps');
        setShowLocationModal(false);
        setMobileTab('map');
        setTimeout(() => {
          try {
            if (mapRef.current) {
              mapRef.current.resize();
              mapRef.current.flyTo({ center: [longitude, latitude], zoom: 14, duration: 1000 });
            }
          } catch(e) {}
        }, 100);
        showToast('📍 Konumunuz bulundu!');
      },
      (err) => {
        if (err.code === 1) {
          setShowLocPermModal(true);
        } else {
          setLocModalGpsError(`Konum alınamadı (${err.code}): ${err.message}`);
          setLocModalStep('gps_error');
        }
      },
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 60000 }
    );
  };

  const handleManualApply = () => {
    if (!locModalIl) return;
    const il = locModalIl;
    const ilce = locModalIlce;
    const query = ilce ? `${ilce} ${il} Türkiye` : `${il} Türkiye`;
    const zoom = ilce ? 13 : 10;
    setSelectedIl(il);
    if (ilce) setSelectedIlce(ilce);
    fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${MAPBOX_TOKEN}&country=TR&limit=1`)
      .then(r => r.json())
      .then(d => {
        if (d.features?.[0]) {
          const center = d.features[0].center;
          if (ilce) ilceCenterRef.current = center;
          setUserPos(center);
          setLocLabel(ilce ? `${ilce}, ${il}` : il);
          if (mapRef.current) mapRef.current.flyTo({ center, zoom, duration: 900 });
        }
      });
    localStorage.setItem('okulmap_location_type', 'manual');
    setShowLocationModal(false);
  };

  const bg = C('nav');
  const bord = C('bord2');
  const txt2 = 'rgba(255,255,255,0.4)';

  const isDesktop = !isMobile;
  return (
    <div style={{position:'fixed',inset:0,zIndex:9990,display:'flex',flexDirection:'column',alignItems:isDesktop?'center':'stretch',justifyContent:isDesktop?'center':'flex-end',background:'rgba(0,0,0,0.65)',backdropFilter:'blur(6px)'}} onClick={(isDesktop||locModalStep==='gps_loading')?()=>{ if(locModalStep==='gps_loading'){setLocModalStep('choose');return;} localStorage.setItem('okulmap_location_type','skip'); setShowLocationModal(false); }:undefined}>
      <div style={{background:bg,borderRadius:isDesktop?20:'24px 24px 0 0',border:isDesktop?'1px solid '+bord:'none',borderTop:isDesktop?'none':'1px solid '+bord,padding:isDesktop?'28px 32px':'20px 20px calc(28px + env(safe-area-inset-bottom,0px))',maxHeight:isDesktop?'90vh':'82vh',width:isDesktop?420:undefined,overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
        <div style={{width:40,height:4,borderRadius:2,background:'rgba(255,255,255,0.15)',margin:'0 auto 24px',display:isDesktop?'none':'block'}}/>

        {/* SEÇIM */}
        {locModalStep === 'choose' && (<>
          <div style={{textAlign:'center',marginBottom:28}}>
            <div style={{fontSize:36,marginBottom:10}}>📍</div>
            <div style={{color:'#fff',fontSize:18,fontWeight:800,fontFamily:'Syne,sans-serif',marginBottom:6}}>Konumunuzu Belirleyin</div>
            <div style={{color:txt2,fontSize:13,lineHeight:1.5}}>Yakındaki okulları görebilmek için konumunuzu seçin</div>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:10,marginBottom:14}}>
            <button onClick={handleGPSInModal} style={{display:'flex',alignItems:'center',gap:16,padding:'16px 18px',borderRadius:16,background:'rgba(168,218,255,0.07)',border:'1.5px solid rgba(168,218,255,0.3)',cursor:'pointer',textAlign:'left',width:'100%'}}>
              <div style={{width:46,height:46,borderRadius:13,background:'rgba(168,218,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,flexShrink:0}}>📍</div>
              <div>
                <div style={{color:'#A8DAFF',fontSize:14,fontWeight:700,marginBottom:2}}>Konumumu Kullan</div>
                <div style={{color:txt2,fontSize:12}}>Otomatik konum tespiti</div>
              </div>
            </button>
          </div>
          <button onClick={()=>{ localStorage.setItem('okulmap_location_type','skip'); setShowLocationModal(false); }} style={{width:'100%',padding:10,background:'none',border:'none',color:txt2,fontSize:12,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
            Şimdi değil
          </button>
        </>)}

        {/* GPS YÜKLENİYOR */}
        {locModalStep === 'gps_loading' && (
          <>
            <div style={{display:'flex',justifyContent:'flex-end',marginBottom:4}}>
              <button onClick={()=>setLocModalStep('choose')} style={{background:'none',border:'none',color:txt2,fontSize:20,lineHeight:1,cursor:'pointer',padding:'4px 6px'}}>✕</button>
            </div>
            <div style={{textAlign:'center',padding:'16px 0 32px'}}>
              <div style={{fontSize:40,marginBottom:16}}>📡</div>
              <div style={{color:'#fff',fontSize:15,fontWeight:700,marginBottom:8}}>Konum alınıyor...</div>
              <div style={{color:txt2,fontSize:12}}>Lütfen konum iznine izin verin</div>
            </div>
          </>
        )}

        {/* GPS HATASI */}
        {locModalStep === 'gps_error' && (<>
          <div style={{textAlign:'center',marginBottom:24}}>
            <div style={{fontSize:40,marginBottom:12}}>⚠️</div>
            <div style={{color:'#fff',fontSize:15,fontWeight:700,marginBottom:8}}>Konum Alınamadı</div>
            <div style={{color:txt2,fontSize:13,lineHeight:1.6}}>{locModalGpsError}</div>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:10}}>
            <button onClick={()=>setLocModalStep('choose')} style={{padding:'12px',borderRadius:14,background:'rgba(255,255,255,0.05)',border:'1px solid '+bord,color:txt2,fontSize:13,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
              ← Geri
            </button>
          </div>
        </>)}

      </div>
    </div>
  );
}

export function MobileLocationSheet({ theme, showMobileLocation, setShowMobileLocation, selectedIl, setSelectedIl, selectedIlce, setSelectedIlce, ilQuery, setIlQuery }) {
  const C = makeC(theme);
  if (!showMobileLocation) return null;
  return (
    <div style={{position:'fixed',inset:0,zIndex:500,display:'flex',flexDirection:'column',justifyContent:'flex-end',background:'rgba(0,0,0,0.5)',backdropFilter:'blur(4px)'}} onClick={()=>setShowMobileLocation(false)}>
      <div style={{background:C('bg'),borderRadius:'20px 20px 0 0',borderTop:'1px solid '+C('bord'),padding:'20px 20px calc(20px + env(safe-area-inset-bottom,0px))',maxHeight:'70vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
        <div style={{width:40,height:4,borderRadius:2,background:C('bord2'),margin:'0 auto 20px'}}/>
        <div style={{fontSize:14,fontWeight:700,color:C('txt'),marginBottom:16}}>Konum Seç</div>

        {/* İl */}
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:C('txt3'),fontWeight:600,marginBottom:6,letterSpacing:'0.06em'}}>İL</div>
          <div style={{display:'flex',alignItems:'center',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:10,padding:'0 12px'}}>
            <input key={'mobile-il-search-'+(selectedIl||'none')} defaultValue="" autoFocus onChange={e=>setIlQuery(e.target.value)} placeholder="İl ara..."
              style={{flex:1,background:'none',border:'none',outline:'none',color:C('txt'),fontSize:16,padding:'10px 0',fontFamily:'DM Sans,sans-serif',touchAction:'manipulation'}}/>
          </div>
          <div style={{maxHeight:180,overflowY:'auto',marginTop:6,borderRadius:10,border:'1px solid '+C('bord'),background:C('inp')}}>
            {TURKEY_CITIES.filter(c=>!ilQuery.trim()||c.il.toLowerCase().includes(ilQuery.toLowerCase())).map(c=>(
              <div key={c.il} onClick={()=>{setSelectedIl(c.il);setSelectedIlce('');setIlQuery('');}}
                style={{padding:'9px 12px',cursor:'pointer',fontSize:13,color:selectedIl===c.il?'#A8DAFF':C('txt'),background:selectedIl===c.il?'rgba(168,218,255,0.08)':'transparent',borderBottom:'1px solid '+C('bord'),fontWeight:selectedIl===c.il?700:400}}>
                {c.il}
              </div>
            ))}
          </div>
        </div>

        {/* İlçe */}
        {selectedIl && (
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,color:C('txt3'),fontWeight:600,marginBottom:6,letterSpacing:'0.06em'}}>İLÇE</div>
            <div style={{maxHeight:160,overflowY:'auto',borderRadius:10,border:'1px solid '+C('bord'),background:C('inp')}}>
              <div onClick={()=>setSelectedIlce('')}
                style={{padding:'9px 12px',cursor:'pointer',fontSize:13,color:!selectedIlce?'#A8DAFF':C('txt'),background:!selectedIlce?'rgba(168,218,255,0.08)':'transparent',borderBottom:'1px solid '+C('bord'),fontWeight:!selectedIlce?700:400}}>
                Tüm İlçeler
              </div>
              {(TURKEY_CITIES.find(c=>c.il===selectedIl)?.ilceler||[]).map(d=>(
                <div key={d} onClick={()=>setSelectedIlce(d)}
                  style={{padding:'9px 12px',cursor:'pointer',fontSize:13,color:selectedIlce===d?'#A8DAFF':C('txt'),background:selectedIlce===d?'rgba(168,218,255,0.08)':'transparent',borderBottom:'1px solid '+C('bord'),fontWeight:selectedIlce===d?700:400}}>
                  {d}
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{display:'flex',gap:8}}>
          {(selectedIl||selectedIlce) && (
            <button onClick={()=>{setSelectedIl('');setSelectedIlce('');}} style={{flex:1,padding:'12px',borderRadius:12,background:'rgba(255,255,255,0.06)',border:'1px solid '+C('bord'),color:C('txt2'),fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
              Temizle
            </button>
          )}
          <button onClick={()=>{ localStorage.setItem('okulmap_location_type','manual'); setShowMobileLocation(false); }} style={{flex:2,padding:'12px',borderRadius:12,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
            Uygula
          </button>
        </div>
      </div>
    </div>
  );
}

export function MobileBottomNav({ theme, favs, compareList, mobileTab, setMobileTab, mapRef }) {
  const C = makeC(theme);
  const isDark = theme === 'dark';
  const favCount = favs.length;
  const cmpCount = compareList.length;
  const TABS = [
    {id:'map',     Icon: MapsIcon,         label:'Ana Sayfa'},
    {id:'events',  Icon: Megaphone02Icon,  label:'Kampanyalar'},
    {id:'favs',    Icon: FavouriteIcon,    label:'Favoriler',  badge: favCount},
    {id:'compare', Icon: BalanceScaleIcon, label:'Karşılaştır', badge: cmpCount},
    {id:'profile', Icon: User02Icon,       label:'Profil'},
  ];
  // iOS double-tap fix — onTouchEnd ile direkt çalıştır, click backup desktop için
  const handleTabSelect = (tabId) => {
    if (mobileTab === tabId) return;  // aynı tab'a tekrar push etme
    setMobileTab(tabId);
    if (tabId === 'map') setTimeout(()=>mapRef.current?.resize(),100);
  };
  return (
    <div style={{position:'fixed',bottom:0,left:0,right:0,background:C('nav'),backdropFilter:'blur(24px)',WebkitBackdropFilter:'blur(24px)',borderTop:'1px solid '+C('bord'),display:'flex',justifyContent:'space-around',zIndex:200,paddingTop:10,paddingBottom:'calc(16px + env(safe-area-inset-bottom))',touchAction:'manipulation'}}>
      {TABS.map(t => {
        const isAct = mobileTab === t.id;
        return (
          <button
            key={t.id}
            onTouchEnd={(e) => {
              e.preventDefault();
              e.currentTarget.blur();
              handleTabSelect(t.id);
            }}
            onClick={(e) => {
              // Desktop / fallback — touchend zaten ateşlediyse re-fire'ı önle
              if (e.detail === 0) return;  // synthetic click (touchend sonrası)
              handleTabSelect(t.id);
            }}
            style={{display:'flex',flexDirection:'column',alignItems:'center',gap:3,background:'none',border:'none',cursor:'pointer',padding:'4px 12px',position:'relative',fontFamily:'DM Sans,sans-serif',touchAction:'manipulation',WebkitTapHighlightColor:'transparent'}}>
            <t.Icon size={22} color={isAct?(isDark?'#A8DAFF':'#8B5CF6'):C('txt3')} />
            <span style={{fontSize:10,fontWeight:isAct?600:400,color:isAct?(isDark?'#A8DAFF':'#8B5CF6'):C('txt3')}}>{t.label}</span>
            {isAct && <div style={{width:4,height:4,borderRadius:'50%',background:isDark?'#A8DAFF':'#8B5CF6',boxShadow:'0 0 6px '+(isDark?'#A8DAFF':'#8B5CF6')}} />}
            {t.badge>0 && <div style={{position:'absolute',top:0,right:6,width:16,height:16,borderRadius:'50%',background:isDark?'#A8DAFF':'#8B5CF6',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:800,color:isDark?'#000':'#fff'}}>{t.badge}</div>}
          </button>
        );
      })}
    </div>
  );
}
